<template>
    <form-row title="Has the Survey been Scheduled?" :no_border="true" class="mt-8">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="survey_is_scheduled"
                v-model="survey_is_scheduled"
                true="Yes"
                false="No"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        value: {},
        read_only: { default: false },
    },

    computed: {
        survey_is_scheduled: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
}
</script>
